import React from 'react';
import { ChipBase, getChipIconColor } from './style';

/**
 * -----------------------------------------------------------------------
 * View / Filter / Slice chip icons
 * -----------------------------------------------------------------------
 * Previously these SVGs were copy-pasted inline in both filters.js and
 * lhs.js (lhs.js alone had 2 copies each - one for the info legend and one
 * for the hover action pill). They now live here as the single source of
 * truth, parameterized by `color` so callers don't need to know whether a
 * given icon uses `fill` or `stroke`.
 */
export const ViewIcon = ({
  color = '#4F46E5',
  width = 18,
  height = 13,
  viewBox = '0 0 18 13',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.9999 0C12.8804 0 16.2283 3.41178 17.5774 5.03815C17.5782 5.03971 17.5798 5.04126 17.5813 5.04282C18.1396 5.7278 18.1396 6.71212 17.5813 7.39709C17.5798 7.39864 17.579 7.4002 17.5774 7.40175C16.2285 9.02831 12.8796 12.4399 8.9999 12.4399C5.11938 12.4399 1.77149 9.02813 0.422382 7.40175C0.421605 7.4002 0.420827 7.39864 0.419272 7.39709C-0.139757 6.7121 -0.139757 5.72778 0.419272 5.04282C0.420827 5.04126 0.421605 5.03971 0.422382 5.03815C1.77135 3.4116 5.12017 0 8.9999 0ZM8.9999 1.24401C5.53299 1.24401 2.59095 4.37355 1.38256 5.82974C1.19829 6.05677 1.19829 6.38332 1.38334 6.61037C2.59081 8.06664 5.53297 11.1961 8.99988 11.1961C12.4676 11.1961 15.4088 8.06656 16.6178 6.61037C16.8021 6.38334 16.8021 6.05679 16.617 5.82974C15.4088 4.37347 12.4676 1.24401 8.9999 1.24401ZM8.9999 2.48803C11.0596 2.48803 12.7319 4.16044 12.7319 6.22007C12.7319 8.27969 11.0595 9.9521 8.9999 9.9521C6.94027 9.9521 5.26866 8.27969 5.26866 6.22007C5.26866 4.16044 6.94029 2.48803 8.9999 2.48803ZM8.9999 3.73204C7.62683 3.73204 6.51267 4.84699 6.51267 6.22007C6.51267 7.59314 7.62685 8.70809 8.9999 8.70809C10.373 8.70809 11.4879 7.59314 11.4879 6.22007C11.4879 4.84699 10.373 3.73204 8.9999 3.73204Z"
      fill={color}
    />
  </svg>
);

export const FilterIcon = ({
  color = '#102554',
  width = 14,
  height = 13,
  viewBox = '0 0 14 13',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    {...props}
  >
    <path
      d="M5.78711 7.31445L5.58398 7.11035L1.01367 2.5127L1.0127 2.51172C0.702208 2.20014 0.616268 1.76695 0.785156 1.35547C0.955788 0.945952 1.32399 0.700364 1.76758 0.700195H11.7314C12.1199 0.700222 12.4507 0.888258 12.6416 1.20996L12.7139 1.35547C12.8831 1.7666 12.7979 2.20025 12.4873 2.5127V2.51367L7.91602 7.11035L7.71289 7.31543V12.1621L5.78711 11.4082V7.31445Z"
      stroke={color}
      strokeWidth="1.4"
    />
  </svg>
);

export const SliceIcon = ({
  color = '#B62196',
  width = 14,
  height = 12,
  viewBox = '0 0 14 12',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    {...props}
  >
    <path
      d="M13.0442 2.92482L10.5657 0.446993C9.96975 -0.148998 8.93155 -0.148998 8.33553 0.446993L7.34463 1.43789C7.04697 1.73555 6.88269 2.13178 6.88269 2.55298C6.88269 2.65745 6.89321 2.76062 6.91292 2.86115L0.466201 9.30787C0.00623057 9.76718 -0.124524 10.4256 0.123847 11.0255C0.372235 11.6261 0.930764 12 1.58129 12C1.61152 12 1.64109 11.9974 1.67 11.9921L7.39389 11.0078C7.94717 10.9907 8.45313 10.6832 8.72253 10.1976L10.728 6.58817C10.7977 6.59737 10.866 6.60854 10.937 6.60854C11.3588 6.60854 11.755 6.44426 12.052 6.1466L13.0443 5.1557C13.6573 4.54 13.6573 3.5399 13.0442 2.92482ZM7.80514 9.68694C7.71183 9.85319 7.53572 9.95767 7.34517 9.95767C7.31494 9.95767 7.28537 9.9603 7.25646 9.96556L1.54367 10.9472C1.24601 10.9288 1.12575 10.6975 1.09553 10.624C1.06399 10.5484 0.97922 10.2816 1.20986 10.0516L7.46868 3.79214L9.79023 6.11436L7.80512 9.68761L7.80514 9.68694ZM12.3011 4.41252L11.3088 5.40342C11.1117 5.60186 10.7648 5.60186 10.5657 5.40342L8.08784 2.92425C7.98862 2.82568 7.93343 2.6936 7.93343 2.55365C7.93343 2.41369 7.98797 2.28095 8.08784 2.1824L9.07874 1.1915C9.18125 1.08899 9.31596 1.03774 9.44999 1.03774C9.5847 1.03774 9.71941 1.08834 9.82125 1.1915L12.2991 3.66933C12.5047 3.875 12.5047 4.20814 12.2991 4.41382L12.3011 4.41252Z"
      fill={color}
    />
  </svg>
);

const CHIP_ICONS = {
  view: ViewIcon,
  filter: FilterIcon,
  slice: SliceIcon,
};

const CHIP_ICON_SIZE = {
  view: { width: 18, height: 13, viewBox: '0 0 18 13' },
  filter: { width: 14, height: 13, viewBox: '0 0 14 13' },
  slice: { width: 14, height: 12, viewBox: '0 0 14 12' },
};

/**
 * -----------------------------------------------------------------------
 * Chip
 * -----------------------------------------------------------------------
 * The single reusable "View / Filter / Slice" chip component.
 *
 * Two visual flavors (variant prop):
 *   - "label"  (default): static section-header pill, as used at the top
 *     of the View / Filter / Slice panels in filters.js.
 *   - "action": interactive quick-add pill, as used in the LHS field
 *     hover tooltip and info-legend in lhs.js.
 *
 * States:
 *   - normal:      default colored pill for its type
 *   - muted:       dimmed, e.g. Filter/Slice pills before any View is added
 *   - disabled:    dimmed + non-interactive, e.g. an action pill for a field
 *                  that can't be added right now
 *   - hover:       only applies to variant="action" when interactive
 *   - non-interactive / readonly: variant="action" chips used purely as a
 *     legend (interactive={false}) - normal colors, no hover/click behavior
 */
export const Chip = ({
  type = 'view',
  variant = 'label',
  muted = false,
  disabled = false,
  interactive = variant === 'action',
  onClick,
  className = '',
  style,
  iconWidth,
  iconHeight,
  ...rest
}) => {
  const Icon = CHIP_ICONS[type] || CHIP_ICONS.view;
  const size = CHIP_ICON_SIZE[type] || CHIP_ICON_SIZE.view;
  const isDimmed = muted || disabled;
  const iconColor = getChipIconColor(type, isDimmed);

  return (
    <ChipBase
      type={type}
      chipVariant={variant}
      muted={muted}
      disabled={disabled}
      interactive={interactive}
      onClick={disabled ? undefined : onClick}
      className={`chip chip--${type} chip--${variant}${disabled ? ' disabled' : ''}${className ? ` ${className}` : ''}`}
      style={style}
      {...rest}
    >
      {type === 'view' && 'View'}
      {type === 'filter' && 'Filter'}
      {type === 'slice' && 'Slice'}
      <Icon
        width={iconWidth || size.width}
        height={iconHeight || size.height}
        viewBox={size.viewBox}
        color={iconColor}
      />
    </ChipBase>
  );
};

export default Chip;
